export default __webpack_public_path__ + "static/media/kaus-quote-4.f480e33c.jpg";